"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IllustrationPassengers = function IllustrationPassengers() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "66",
    height: "65",
    fill: "none",
    viewBox: "0 0 66 65"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "65",
    height: "65",
    x: "0.263",
    fill: "#F3F1F5",
    rx: "22"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "20.99",
    cy: "20.495",
    r: "3.495",
    fill: "#E2DBE9",
    stroke: "#77558A",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "42.28",
    cy: "20.495",
    r: "3.495",
    fill: "#E2DBE9",
    stroke: "#77558A",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    stroke: "#77558A",
    strokeWidth: "1.5",
    d: "M42.464 25.093a3.31 3.31 0 00-3.311 3.311l1.25 8.9a1.84 1.84 0 001.82 1.585h6.127l1.73 9.121a1.595 1.595 0 003.136-.58l-1.834-10.156a1.84 1.84 0 00-1.81-1.512h-3.246l-.551-7.358a3.31 3.31 0 00-3.311-3.31zM21.174 25.093a3.31 3.31 0 00-3.311 3.311l1.249 8.9a1.84 1.84 0 001.822 1.585h6.126l1.73 9.121a1.595 1.595 0 003.136-.58l-1.834-10.156a1.84 1.84 0 00-1.81-1.512h-3.246l-.551-7.358a3.31 3.31 0 00-3.311-3.31z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#77558A",
    strokeWidth: "1.5",
    d: "M17.727 44h4.817a1.228 1.228 0 000-2.456h-4.288c-1.269 0-2.346-.93-2.53-2.186l-1.352-9.19a1.123 1.123 0 00-2.224.319l1.365 9.845A4.252 4.252 0 0017.727 44zM38.833 44h4.817a1.228 1.228 0 000-2.456h-4.287c-1.27 0-2.347-.93-2.532-2.186l-1.351-9.19a1.123 1.123 0 00-2.224.319l1.365 9.845A4.252 4.252 0 0038.833 44z"
  }));
};

var _default = IllustrationPassengers;
exports.default = _default;